import React from "react";
import ReactApexChart from "react-apexcharts";

function ProductPieChart({ productData, productCount }) {
  class ApexChart extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
        series: productCount,
        options: {
          chart: {
            type: "pie",
            width: "100%", // Optional - full width of container
            height: 400, // You can adjust this height
          },
          labels: productData,
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  height: 300,
                },
                legend: {
                  position: "bottom",
                },
              },
            },
          ],
        },
      };
    }

    render() {
      return (
        <div>
          <div id="chart">
            <ReactApexChart
              options={this.state.options}
              series={this.state.series}
              type="pie"
              height={this.state.options.chart.height}
            />
          </div>
        </div>
      );
    }
  }

  return <ApexChart />;
}

export default ProductPieChart;
